import React, { useEffect, useCallback, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useSelector, useDispatch } from 'react-redux';
import { SWITCH_MODAL } from '../../../../redux/types';
import { RootState } from '../../../../redux/store';
import useClickOutside from '../../../../common/hooks/useClickOutside';
import useTranslate from '../../../../common/hooks/useTranslate';
import Icon from '../../icon/icon';

import './actionForbidden.scss';

const modalElement = document.getElementById('modal-root');

export const ActionForbidden = () => {
  const showModal = useSelector((state: RootState) => state.modal.showModal);
  const dispatch = useDispatch();
  const { t } = useTranslate();

  const close = () => {
    dispatch({ type: SWITCH_MODAL });
  };

  const modalRef = useRef(null);

  const handleEscape = useCallback(
    (event) => {
      if (event.keyCode === 27) close();
    },
    [close]
  );

  useEffect(() => {
    if (showModal) document.addEventListener('keydown', handleEscape, false);
    return () => {
      document.removeEventListener('keydown', handleEscape, false);
    };
  }, [handleEscape, showModal]);

  useClickOutside(modalRef, close);

  return createPortal(
    showModal ? (
      <div className={`modal`}>
        <div className="modal-body" ref={modalRef}>
          <div className={'modal-title'}>
            <Icon name="fas fa-xmark" className="impersonate-off-icon pointer" onClick={close} />
          </div>
          <Icon name={'fas fa-masks-theater'} className="impersonate-icon" />
          <h1>{t('ACTION_FORBIDDEN.TEXT1')}</h1>
          <h2>{t('ACTION_FORBIDDEN.TEXT2')}</h2>
        </div>
      </div>
    ) : null,
    modalElement
  );
};

export default ActionForbidden;
